import React from 'react';
import connectToStores from 'alt-utils/lib/connectToStores';
import moment from 'moment';
import PastPlanActions from 'actions/coaching/PastPlanActions';
import PastPlanStore from 'stores/coaching/PastPlanStore';
import CoachingPlanStore from 'stores/coaching/CoachingPlanStore';
import PastPlansList from 'components/coaching/landing-pages/PastPlansList';
import {shouldUpdate} from 'components/StatsPage2.utils';

/**
 * Component that renders past coaching plans coached by the user given by props.coachId.
 */
@connectToStores
export default class PastPlansContainer extends React.PureComponent {
  static getStores() {
    return [PastPlanStore, CoachingPlanStore];
  }

  static getPropsFromStores() {
    const pastPlanStore = PastPlanStore.getState().toObject();
    const {coachingPlansLoading, coachingPlans} = CoachingPlanStore.getState();

    return {
      ...pastPlanStore,
      coachingPlans,
      coachingPlansLoading,
    };
  }

  componentDidMount() {
    this.fetchPastPlans();
  }

  // hacky solution for sibling updates.
  componentDidUpdate(prevProps) {
    const currProps = this.props;

    // Already loading. Don't bother doing it again.
    if (currProps.pastPlansLoading || prevProps.pastPlansLoading) {
      return;
    }
    // Wait until plans have loaded to compare.
    if (currProps.coachingPlansLoading) {
      return;
    }
    // Coaching plans have changed somehow (possibly one was ended, for example).
    const coachingPlansChanged = currProps.coachingPlans !== prevProps.coachingPlans;
    const filterChanged = shouldUpdate(prevProps, currProps, true, true);

    // if our date range/selected team changed, or plans changed, refresh our data.
    if (coachingPlansChanged || filterChanged) {
      this.fetchPastPlans();
    }
  }

  fetchPastPlans() {
    const {coachId, startDate, endDate} = this.props;
    const midnight = moment().startOf('day');
    const end = midnight.isSame(endDate, 'day')
      ? // EV-16936. Include plans completed today in the current table. This is an exception to
        // the dashboard date filtering.
        endDate.clone().add(1, 'day')
      : endDate;
    const args = {
      coachId,
      start: startDate.format(),
      end: end.format(),
    };
    PastPlanActions.getPastPlans.defer(args);
  }

  render() {
    // Obviously can't render if past plans are still loading. Somewhat less
    // obviously, if we don't have the coach yet, we can't render the table
    // header. A later rendering cycle should get it once it's fetched from the
    // server.
    if (this.props.pastPlansLoading || !this.props.coach) {
      return null;
    }

    const whoCoached = this.props.isManagerLoggedIn
      ? 'You Have'
      : `${this.props.coach.firstName} Has`;
    // TODO: replace the date picker with the new component below once
    // https://repo.execvision.io/dev/web/merge_requests/2910 is merged.
    return (
      <div className="past-plans-list mgr-landing-card-container">
        <div className="past-plans-header">
          <h2 className="subheader past-plans-header">Reps {whoCoached} Previously Coached</h2>
        </div>
        <PastPlansList {...this.props} coachId={this.props.dashCoachId} />
      </div>
    );
  }
}
